import auth from "./auth";
import informations from "./informations";
import notifications from "./notifications";
import printer from "./printer";
import reports from "./reports";
import agreements from "./agreements";
import users from "./users";
import alerts from "./alerts";
import customers from "./customers";
import dashboard from "./dashboard";
import pins from "./pins";
import fleets from "./fleets";
import hubs from "./hubs";
import drivers from "./drivers";
import driver_activities from "./driver_activities";
import types from "./types";
import type_activities from "./type_activities";
import pois from "./pois";
import tractors from "./tractors";
import vehicles from "./vehicles";
import vehicle_rents from "./vehicle_rents";
import eyegeo from "./eyegeo";
import eyecrono from "./eyecrono";
import eyecold from "./eyecold";
import eyesafe from "./eyesafe";
import eyecontrol from "./eyecontrol";
import eyedoor from "./eyedoor";
import eyefuel from "./eyefuel";
import eyepower from "./eyepower";
import carbontax from "./carbontax";
import eyeway from "./eyeway";
import eyeservice from "./eyeservice";
import tandt from "./tandt";

const api = {
  auth,
  informations,
  reports,
  notifications,
  agreements,
  alerts,
  dashboard,
  customers,
  users,
  pins,
  fleets,
  hubs,
  pois,
  drivers,
  driver_activities,
  types,
  type_activities,
  tractors,
  vehicles,
  vehicle_rents,
  carbontax,
  eyegeo,
  eyecrono,
  eyecold,
  eyecontrol,
  eyedoor,
  eyesafe,
  eyefuel,
  eyepower,
  eyeway,
  eyeservice,
  tandt,
  printer,
};

export {
  api as default,
  auth,
  reports,
  informations,
  notifications,
  dashboard,
  agreements,
  alerts,
  customers,
  users,
  pins,
  fleets,
  hubs,
  drivers,
  driver_activities,
  types,
  type_activities,
  pois,
  tractors,
  carbontax,
  vehicles,
  vehicle_rents,
  eyegeo,
  eyecold,
  eyecrono,
  eyecontrol,
  eyedoor,
  eyefuel,
  eyesafe,
  eyepower,
  eyeway,
  eyeservice,
  tandt,
  printer,
};
